<template>
  <v-alert
    :color="!notification.unread ? 'accent lighten-5' : 'primary lighten-1'"
    border="left"
    text
    elevation="0"
    :class="{ 'py-6': !dense }"
    class="pl-6"
    icon="mdi-check-all"
  >
    <div class="d-flex justify-sm-space-between">
      <span>
        <span class="subtitle-2 accent--text">
          {{ lo.capitalize(notification.verb || "") }}
        </span>
        <span class="subtitle-2 grey--text font-weight-light ml-4">{{
          duration(notification)
        }}</span>
      </span>
    </div>
    <template v-slot:append>
      <v-slide-x-reverse-transition mode="out-in">
        <v-btn
          v-if="!readOnly && notification.unread"
          x-small
          text
          color="grey lighten-1"
          @click="markAsRead"
        >
          <v-icon left>mdi-email-check</v-icon>
          Mark as read
        </v-btn>
      </v-slide-x-reverse-transition>
    </template>
  </v-alert>
</template>

<script>
import moment from "moment"
import NotificationService from "@/services/hmd/NotificationService"
export default {
  props: {
    readOnly: {
      type: Boolean,
      default: false
    },
    dense: {
      type: Boolean,
      default: false
    },
    notification: {
      type: Object,
      default: () => ({
        color: null,
        subject: null,
        created_at: null
      })
    }
  },
  methods: {
    duration(v) {
      return moment(v.timestamp).fromNow()
    },
    markAsRead() {
      NotificationService.markAsRead(this, this.notification.slug).then(r => {
        this.$store.commit("setNotifications")
        // for (let i = 0; i < this.$store.state.notifications.length; i++) {
        //   const n = this.$store.state.notifications[i]
        //   if (n === this.notification) {
        //     this.$store.state.notifications[i].unread = false
        //     return
        //   }
        // }
      })
    }
  },
  data() {
    return {}
  }
}
</script>

<style lang="scss" scoped></style>
